export const GetSeatName = (vid) => {
    switch (vid) {
        case 'BASE': return 'Основное место';
        case 'EXT': return 'Доп. месте';
        case 'NO_PLACE': return 'Без места';
        default: return vid;
    }
}